import { render, staticRenderFns } from "./SiteSettings.vue?vue&type=template&id=6230111e"
import script from "./SiteSettings.vue?vue&type=script&lang=ts"
export * from "./SiteSettings.vue?vue&type=script&lang=ts"
import style0 from "./SiteSettings.vue?vue&type=style&index=0&id=6230111e&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports